export enum SavedSearchActiveModal {
  PostSaved = 'postSaved',
  ExistingSearch = 'existingSearch',
  EnhanceSearch = 'enhanceSearch',
}
